const modalBackdrop = "_modalBackdrop_1g3nn_3";
const modalFooter = "_modalFooter_1g3nn_10";
const modalHeader = "_modalHeader_1g3nn_15";
const modalHeaderButton = "_modalHeaderButton_1g3nn_24";
const modalEntering = "_modalEntering_1g3nn_37";
const modalExiting = "_modalExiting_1g3nn_41";
const rotation = "_rotation_1g3nn_1";
const styles = {
  modalBackdrop,
  modalFooter,
  modalHeader,
  modalHeaderButton,
  modalEntering,
  "fade-in": "_fade-in_1g3nn_1",
  modalExiting,
  "fade-out": "_fade-out_1g3nn_1",
  rotation
};
export {
  styles as s
};
